module.exports = __webpack_public_path__ + "static/media/ka-graph.3dfc997e.mp4";